import React from "react";
import Navbar from "./Navbar";
import Footer from "./Footer";
import { LineChart, BarChart3, Mail, Phone } from "lucide-react";
import FadeInOnScroll from "./FadeInOnScroll";
import FadeInCard from "./FadeInCard";
import SlideInOnScroll from "./SlideInOnScroll";

export default function Investor() {
  return (
    <>
      <section className="relative overflow-hidden bg-gradient-to-br from-purple-50 via-white to-purple-100 text-[#1e0b44] py-24 px-6">
        {/* 背景装饰图形 */}
        <div className="absolute inset-0 overflow-hidden pointer-events-none">
          <div className="absolute w-96 h-96 bg-purple-300/20 rounded-full blur-3xl top-10 -left-20 animate-pulse"></div>
          <div className="absolute w-[28rem] h-[28rem] bg-indigo-300/30 rounded-full blur-3xl bottom-0 right-0 animate-pulse"></div>
        </div>

        {/* 标题区 */}
        <div className="relative max-w-6xl mx-auto text-center mb-20">
          <FadeInOnScroll>
            <h2 className="text-5xl md:text-6xl font-extrabold bg-gradient-to-r from-[#6a2dd9] to-[#9a8dfc] bg-clip-text text-transparent">
              INVESTOR RELATIONS
            </h2>
            <p className="text-[#5e4ca8] font-medium text-lg mt-4 tracking-wide">
              Transparency • Growth • Value Creation
            </p>
            <div className="mx-auto mt-6 w-32 h-1 bg-gradient-to-r from-[#a076f9] to-[#7b5cff] rounded-full"></div>
          </FadeInOnScroll>
        </div>

        {/* 内容区 */}
        <div className="relative max-w-6xl mx-auto grid md:grid-cols-2 gap-12">
          {/* Investor Overview —— 上面左 */}
          <FadeInCard>
            <div className="group bg-white/80 backdrop-blur-lg border border-white/50 shadow-[0_10px_30px_rgba(138,79,255,0.15)] p-10 rounded-3xl hover:shadow-[0_14px_40px_rgba(138,79,255,0.25)] transition-all duration-300">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#a076f9] to-[#7b5cff] text-white rounded-xl shadow-md">
                  <LineChart size={26} />
                </div>
                <h3 className="text-2xl font-bold text-[#5b1fc2]">
                  Investor Overview
                </h3>
              </div>
              <p className="text-[#2a0f4c]/90 leading-relaxed text-justify">
                AI NOVA is committed to building sustainable, long-term
                shareholder value through strategic growth, innovation, and
                corporate responsibility. Our investment philosophy emphasizes
                technology excellence, transparency, and measurable market
                impact.
              </p>
            </div>
          </FadeInCard>

          {/* Financial Highlights —— 上面右 */}
          <FadeInCard delay={0.1}>
            <div className="group bg-white/80 backdrop-blur-lg border border-white/50 shadow-[0_10px_30px_rgba(138,79,255,0.15)] p-10 rounded-3xl hover:shadow-[0_14px_40px_rgba(138,79,255,0.25)] transition-all duration-300">
              <div className="flex items-center gap-3 mb-6">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#ffb35c] to-[#ff8845] text-white rounded-xl shadow-md">
                  <BarChart3 size={26} />
                </div>
                <h3 className="text-2xl font-bold text-[#ff7b28]">
                  Financial Highlights
                </h3>
              </div>
              <ul className="list-disc pl-5 text-[#2a0f4c]/90 space-y-2">
                <li>Consistent double-digit revenue growth across AI services.</li>
                <li>Robust partnership ecosystem driving recurring revenue.</li>
                <li>Strong capital position and disciplined management.</li>
                <li>Continuous investment in cloud infrastructure and R&D.</li>
              </ul>
            </div>
          </FadeInCard>

          {/* Investor Contact —— 下面整行，从左滑入 */}
          <div className="md:col-span-2">{/* ⭐ 这一层控制从左到右铺满 */}
            <SlideInOnScroll from="left" delay={0.15}>
              <div className="group bg-white/80 backdrop-blur-lg border border-white/50 shadow-[0_10px_30px_rgba(138,79,255,0.15)] p-10 rounded-3xl hover:shadow-[0_14px_40px_rgba(138,79,255,0.25)] transition-all duration-300">
                <div className="flex items-center gap-3 mb-6">
                  <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-[#a076f9] to-[#7b5cff] text-white rounded-xl shadow-md">
                    <Mail size={24} />
                  </div>
                  <h3 className="text-2xl font-bold text-[#6a2dd9]">
                    Investor Contact
                  </h3>
                </div>
                <p className="text-[#2a0f4c]/90 leading-relaxed">
                  For investor-related inquiries, please contact our team:
                </p>
                <div className="mt-4 flex flex-col items-start gap-3">
                  <div className="flex items-center gap-3 text-[#1e0b44]">
                    <Mail className="text-[#6a2dd9]" size={20} />
                    <span>getintouch@ainova.sg</span>
                  </div>
                  {/* <div className="flex items-center gap-3 text-[#1e0b44]">
                    <Phone className="text-[#6a2dd9]" size={20} />
                    <span>+65 800 123 4567</span>
                  </div> */}
                </div>
              </div>
            </SlideInOnScroll>
          </div>
        </div>
      </section>
    </>
  );
}
